import * as React from 'react'

function SvgTd(props) {
	return (
		<svg viewBox="0 0 450 300" width="1em" height="1em" {...props}>
			<path fill="#C60C30" d="M0 0h450v300H0z" />
			<path fill="#FECB00" d="M0 0h300v300H0z" />
			<path fill="#002664" d="M0 0h150v300H0z" />
		</svg>
	)
}

export default SvgTd
